import { z } from '@faceup/validation'
import { DisclosureFormStatus, FormItemType } from '../enums'
import { Language } from '../localization/enums'
import {
  dateFormItemSchema,
  emailFormItemSchema,
  multilineTextFormItemSchema,
  multiSelectFormItemSchema,
  numberFormItemSchema,
  phoneNumberFormItemSchema,
  selectFormItemSchema,
  simpleTextFormItemSchema,
  yesNoFormItemSchema,
} from './abstractFormItemSchemas'
import { tiptapContentSchema } from './tiptapContentSchema'

/**
 * Form item types allowed in disclosure forms.
 */
export const allowedDisclosureFormItemTypes = [
  FormItemType.SimpleText,
  FormItemType.MultilineText,
  FormItemType.Select,
  FormItemType.MultiSelect,
  FormItemType.Date,
  FormItemType.Number,
  FormItemType.Email,
  FormItemType.PhoneNumber,
  FormItemType.YesNo,
] as const

export const publicDisclosureFormItemSchema = z.discriminatedUnion('type', [
  simpleTextFormItemSchema,
  dateFormItemSchema,
  numberFormItemSchema,
  emailFormItemSchema,
  phoneNumberFormItemSchema,
  multilineTextFormItemSchema,
  selectFormItemSchema,
  multiSelectFormItemSchema,
  yesNoFormItemSchema,
])

export const publicDisclosureFormSchema = z.object({
  id: z.uuidv7(),
  formId: z.uuidv7(),
  name: z.string().nullable(),
  description: tiptapContentSchema.nullable(),
  status: z.enum(DisclosureFormStatus),
  nameFormItemId: z.string(),
  emailFormItemId: z.string(),
  language: z.enum(Language),
  defaultLanguage: z.enum(Language),
  formItems: z.array(publicDisclosureFormItemSchema),
})

export type PublicDisclosureFormItem = z.infer<typeof publicDisclosureFormItemSchema>
export type PublicDisclosureForm = z.infer<typeof publicDisclosureFormSchema>
